import { API_ENDPOINTS, axiosInstance } from "../../config";

export const getEducation = () => {
    return axiosInstance.get(API_ENDPOINTS.get_education);
}